/** Pull an 11-char video id from a watch URL, youtu.be link, shorts URL, or iframe snippet. */
export function youtubeVideoId(input: string): string | null {
  if (!input) return null
  const trimmed = input.trim()
  const iframeSrc = trimmed.match(/src=["']([^"']+)["']/i)
  const raw = iframeSrc?.[1] ?? trimmed

  if (/^[a-zA-Z0-9_-]{11}$/.test(raw)) return raw

  try {
    const url = new URL(raw.startsWith('http') ? raw : `https://${raw}`)
    const host = url.hostname.replace(/^www\./, '')
    if (host === 'youtu.be') {
      const id = url.pathname.split('/').filter(Boolean)[0]
      return id?.slice(0, 11) ?? null
    }
    if (host === 'youtube.com' || host === 'youtube-nocookie.com' || host === 'm.youtube.com') {
      const fromQuery = url.searchParams.get('v')
      if (fromQuery) return fromQuery
      const parts = url.pathname.split('/').filter(Boolean)
      for (const key of ['embed', 'shorts', 'live', 'v']) {
        const idx = parts.indexOf(key)
        if (idx >= 0 && parts[idx + 1]) return parts[idx + 1]
      }
    }
  } catch {
    return null
  }
  return null
}
